import React, { useMemo, useState } from 'react';
import { getNavTheme } from '../../../../navigation/clinicNavConfig';
import ReputationIcon from './ReputationIcon';
import { REPUTATION_PAGE_THEME } from './reputationTheme';

function ReputationNav({ tabs, activeTab, onTabChange, counts = {} }) {
    const [isOpen, setIsOpen] = useState(true);

    const activeLabel = useMemo(
        () => tabs.find((tab) => tab.id === activeTab)?.label || 'Overview',
        [tabs, activeTab]
    );

    return (
        <div className={`ecx-page-card ecx-page-panel reputation-nav${isOpen ? '' : ' reputation-nav--collapsed'}`}>
            <div className="ecx-page-panel__header reputation-nav__header">
                <button
                    type="button"
                    className="reputation-nav__toggle d-lg-none"
                    onClick={() => setIsOpen((open) => !open)}
                    aria-expanded={isOpen}
                    aria-controls="reputation-nav-body"
                >
                    <div className="d-flex align-items-center gap-2 min-width-0">
                        <ReputationIcon icon="bi-star" theme={REPUTATION_PAGE_THEME} size="sm" />
                        <div className="text-start min-width-0">
                            <h6 className="mb-0 fw-semibold">Reputation</h6>
                            {!isOpen && (
                                <span className="reputation-nav__active small text-muted text-truncate d-block">
                                    {activeLabel}
                                </span>
                            )}
                        </div>
                    </div>
                    <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} reputation-nav__chevron`}></i>
                </button>

                <div className="d-none d-lg-flex align-items-center gap-2">
                    <ReputationIcon icon="bi-star" theme={REPUTATION_PAGE_THEME} size="sm" />
                    <h6 className="mb-0 fw-semibold">Sections</h6>
                </div>
            </div>

            <div id="reputation-nav-body" className="ecx-page-panel__body ecx-page-scroll reputation-nav__body">
                <div className="reputation-nav__list">
                    {tabs.map((tab) => {
                        const theme = getNavTheme(tab.theme);
                        const isActive = activeTab === tab.id;

                        return (
                            <button
                                key={tab.id}
                                type="button"
                                className={`reputation-nav__item ${
                                    isActive ? `${theme.activeClass} is-active` : theme.idleClass
                                }`}
                                onClick={() => onTabChange(tab.id)}
                            >
                                <ReputationIcon
                                    icon={tab.icon}
                                    theme={tab.theme}
                                    size="sm"
                                    className="reputation-nav__item-icon"
                                />
                                <span className="reputation-nav__item-label">{tab.label}</span>
                                {counts[tab.id] != null && (
                                    <span className="reputation-nav__item-count">{counts[tab.id]}</span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default ReputationNav;
